import { useEffect, useRef, useState } from "react";

import { put } from "utils/DeApi";

const useUpdateStatus = ({ statusId, onStatusUpdated }) => {
  const subscribedPromises = useRef([]);

  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const updateStatus = (values) => {
    setError(null);
    setIsLoading(true);

    const statusPromise = put(`/step-statuses/${statusId}`, {
      order: 1,
      label: values?.name,
      color: values?.color,
    });
    statusPromise.promise
      .then(() => {
        onStatusUpdated();
      })
      .catch((error) => !error.isCanceled && setError(error))
      .finally(() => setIsLoading(false));

    subscribedPromises.current.push(statusPromise);
  };

  useEffect(() => {
    const promises = subscribedPromises.current;
    return () => {
      promises.forEach((promise) => promise.cancel());
    };
  }, []);

  return {
    error,
    isLoading,
    updateStatus,
  };
};

export default useUpdateStatus;
